import * as Output from "../../Text";

export function mandatory(field) {

    if (!(field && field.length)) {
        return Output.resolve('generic.errors.M001_mandatoryFields')
    }

    return undefined;
}